import { IApplicationState } from '../../types/redux';

export const selectOfferShareSettings = (state: IApplicationState) => {
  const { shares } = state.shareCollection;
  const selectedFolderId = state.folders.selectedId;

  return shares.find(({ id }) => id === selectedFolderId) || null;
};
